import { AppConfig, UserInfo } from 'pmn/types';
import initFullstory from './fullstorySnippet';

type FullStoryAPI = {
  userId?: UserInfo['id'];
  userTraits?: AdaptedTraits;
  loggedOut?: boolean;
  identify: (id: UserInfo['id'] | false, traits?: AdaptedTraits) => void;
};

function mock(orgId: string) {
  // eslint-disable-next-line no-underscore-dangle
  Object.defineProperty(window, '_fs_org', { value: orgId, writable: false });

  const mockFullStory: FullStoryAPI = {
    identify(id, traits) {
      if (id) {
        this.userId = id;
        this.userTraits = traits;
      } else {
        delete this.userId;
        delete this.userTraits;
        this.loggedOut = true;
      }
    },
  };

  Object.defineProperty(window, 'FS', {
    value: mockFullStory,
    writable: false,
  });
}

type AdaptedTraits = {
  email: string;
};

const adapt = (user: UserInfo['traits']): AdaptedTraits => {
  return {
    email: user.email,
  };
};

export default class FullStory {
  api?: FullStoryAPI;

  init({ FULLSTORY_ENABLED, FULLSTORY_ID }: AppConfig): void {
    if (FULLSTORY_ENABLED) {
      initFullstory(FULLSTORY_ID);
    } else {
      mock(FULLSTORY_ID);
    }

    if (!('FS' in window)) {
      console.error('FullStory not loaded');
      return;
    }
    const extendedWindow = window as typeof window & { FS: FullStoryAPI };
    this.api = extendedWindow.FS as FullStoryAPI;
  }

  identify(userInfo: UserInfo): void {
    const { api } = this;
    if (!api) {
      console.error('FullStory did not initialize');
      return;
    }
    const { id, traits } = userInfo || {};
    if (id) {
      api.identify(id, adapt(traits));
    } else {
      api.identify(false);
    }
  }
}
